import {createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import * as AuthReducers from './auth/reducers';
import * as PaymentReducers from './paymentRequest/reducers';
import * as TemplateReducers from './template/reducers';

function saveToLocal(state) {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (e) {
    console.log(e)
  }
}

function loadFromLocal() {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    console.log(e)
    return undefined
  }
}
const persistedState = loadFromLocal();


// configures the store
const configureStore = (initialState = {}) => {
  // combine reducers
  let reducers = combineReducers(
    Object.assign(
      {},
      AuthReducers,
        PaymentReducers,
        TemplateReducers
    ),
  );

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  // create enhancer
  let enhancer = composeEnhancers(applyMiddleware(thunkMiddleware));

  // create store
  return createStore(reducers, persistedState, enhancer);
};

// configure store
const _store = configureStore();

_store.subscribe(() => saveToLocal(_store.getState()))

// export store
export default _store;
